import { computed, watch } from 'vue'
import { useUserStore } from '@/stores/UserStore'
import { useGlobalStore } from '@/stores/GlobalStore'
import { useConfigStore } from '@/stores/ConfigStore'
import { useRoute } from 'vue-router'

export function useCello() {
  const userStore = useUserStore()
  const globalStore = useGlobalStore()
  const configStore = useConfigStore()
  const route = useRoute()

  const celloToken = computed(() => configStore.config?.celloToken)

  watch(celloToken, () => {
    if (!celloToken.value || globalStore.celloAlreadyBooted) return

    window.cello = window.cello || { cmd: [] }

    window.cello.cmd.push(async function (cello) {
      try {
        await cello.boot({
          productId: import.meta.env.VITE_CELLO_PRODUCT_ID,
          token: celloToken.value,
          language: "en",
          productUserDetails: {
            firstName: userStore.user?.first_name,
            lastName: userStore.user?.last_name,
            fullName: `${userStore.user?.first_name} ${userStore.user?.first_name}`,
            email: userStore.user?.email
          }
        })

        globalStore.celloAlreadyBooted = true

        route.name !== 'Homepage' && window.Cello && window.Cello('hide')
      } catch (error) {
        console.error("Failed to boot cello:", error);
        // Handle the error appropriately
      }
    })
  })
}